module.exports = __webpack_public_path__ + "img/Constancia_2025.63abaa7f.png";